export default "__VITE_ASSET__a3002800__"